import { ResponsiveRow } from '../constants/layout.constants';
import {
	DetailsColumn,
	DetailsContainer,
	DetailsLabel,
	DetailsRow,
	DetailsText,
} from '../constants/component.constants';
import ModalContainerModule from '../components/modules/modalContainer';

export default function CapitalFundView(props) {
	return (
		<ModalContainerModule
			size="sm"
			accept={props.handleApproveCapitalFund}
			reject={props.handleRejectCapitalFund}
			cancel={props.closeModal}
			openModal={props.openModal}
			modalTitle={'Review Capital Fund Approval'}
			acceptButtonText={'Approve'}
			rejectButtonText={'Reject'}		
		>
			<ResponsiveRow sx={{ paddingTop: 0 , height: "auto"}}>
				<DetailsContainer sx={{ width: '100%' }}>
					<DetailsColumn
						sx={{
							width: { lg: '50%', md: '100%', xs: '100%' },
						}}
					>
						
						<DetailsRow>
							<DetailsLabel>Description:</DetailsLabel>
							<DetailsText>{props.pendingItem?.description}</DetailsText>
						</DetailsRow>
						<DetailsRow>
							<DetailsLabel>Status:</DetailsLabel>
							<DetailsText>{props.pendingItem?.status}</DetailsText>
						</DetailsRow>
						<DetailsRow>
							<DetailsLabel>Facility:</DetailsLabel>
							<DetailsText>
								{props.pendingItem?.facility}
							</DetailsText>
						</DetailsRow>
					</DetailsColumn>
					<DetailsColumn
						sx={{
							width: { lg: '50%', md: '100%', xs: '100%' },
						}}
					>
						<DetailsRow>
							<DetailsLabel>Amount:</DetailsLabel>
							<DetailsText>{props.pendingItem?.amount}</DetailsText>
						</DetailsRow>
						<DetailsRow>
							<DetailsLabel>Date:</DetailsLabel>
							<DetailsText>{props.pendingItem?.date}</DetailsText>
						</DetailsRow>	
						<DetailsRow>
							<DetailsLabel>Home Owner:</DetailsLabel>
							<DetailsText>{props.pendingItem?.owner}</DetailsText>
						</DetailsRow>	
						<DetailsRow>
							<DetailsLabel>Unit:</DetailsLabel>
							<DetailsText>{props.pendingItem?.unit}</DetailsText>
						</DetailsRow>			
					</DetailsColumn>
				</DetailsContainer>
			</ResponsiveRow>
		</ModalContainerModule>
	);
}
